import store from '@/store';

import authRoutes from '@/auth/auth.routes';

const router = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...authRoutes,
    {
      path: '*',
      redirect: {
        name: 'redirect',
      },
    },
  ],
};

const beforeEach = async (to, from, next) => {
  // The value of redirectTo would remain undefined if all guard checks pass (or no guards are found)
  let redirectTo;

  // Go through each record in the matched route's chain until a guard check fails.
  // If a check fails, set the redirectTo value
  const mappedGuards = to.matched.map(record => (_.get(record, 'meta.guards', [])
    .map(guard => ({
      redirectOnFail: _.get(record, 'meta.redirectOnFail', '/'),
      ..._.cloneDeep(guard),
    }))));

  const allGuards = _.flatten(mappedGuards);
  await allGuards.reduce(async (previousAsyncCheck, nextGuard) => {
    try {
      const previousCheckPassed = await previousAsyncCheck;
      if (!previousCheckPassed) {
        return false;
      }

      const nextGuardPasses = await nextGuard.check();
      redirectTo = nextGuardPasses ? redirectTo : nextGuard.redirectOnFail;
      return nextGuardPasses;
    } catch {
      return false;
    }
  }, async () => true);

  if (to.path === '/' && to.hash) {
    redirectTo = {
      path: to.hash.replace('#/', ''),
      params: to.params,
    };
  }

  if (redirectTo) {
    redirectTo.query = {
      ...(to.query || {}),
      ...(redirectTo.query || {}),
    };
  }

  next(redirectTo);
};

const afterEach = to => store.commit('setPageTitle', (to.meta || {}).title);

export default {
  router,
  beforeEach,
  afterEach,
};
